import utility from "./utility"

const authentication = {
    init: function () {
        // signin buttons
        const signinButton = document.getElementById("header--sign-in");
        if (signinButton) {
            signinButton.onclick = () => utility.showLoginPopup();
        }

        const loginButton = document.getElementById("button--log-in");
        if (loginButton) {
            loginButton.onclick = () => utility.showLoginPopup();
        }

        const signinForm = document.getElementById("authentication--signin-form");
        if (signinForm) {
            signinForm.onsubmit = () => {
                this.requestLogin();
                return false;
            };
        }

        //SMS Sign In Request SMS
        const smsCodeRequestForm = document.getElementById("authentication--signin-sms");
        if (smsCodeRequestForm) {
            // phone numbers numbers only
            [...smsCodeRequestForm.querySelectorAll("input[name='phoneNumber']")].map(item => {
                item.onkeypress = (e) => {
                    if (e.charCode < 48 || e.charCode > 57) {
                        e.preventDefault();
                    }
                };
            });
            smsCodeRequestForm.onsubmit = () => {
               this.requestSMSCode();
                return false;
            };
        }

        // SMS Code Form Submit
        const smsCodeLoginForm = document.getElementById("authentication--signin-code");
        if (smsCodeLoginForm) {
            //restrict sms code to numeric
            [...smsCodeLoginForm.querySelectorAll("input[name='code']")].map(item => {
                item.onkeypress = (e) => {
                    if (e.charCode < 48 || e.charCode > 57) {
                        e.preventDefault();
                    }
                };
            });
            smsCodeLoginForm.onsubmit = () => {
                this.requestSMSLogin();
                return false;
            };
        }

        //reset forms
        const clearSmsForms = document.getElementById("clear-sms-forms");
        if (clearSmsForms) {
            clearSmsForms.onclick = () => this.clearForms();
        }
                
        //Resend SMS Code
        const resendSmsCode = document.getElementById("resend-sms-code");
        if (resendSmsCode) {
          resendSmsCode.onclick = () => this.resendSMSCode();
        }
       

        // forgot password popup
        const forgotPasswordLink = document.getElementById("global--forgot-password");
        if (forgotPasswordLink) {
            forgotPasswordLink.onclick = () => authentication.showRequestResetPasswordPopup();
        }
        const forgotPassordForm = document.querySelector("#global--forgot-password-form");
        if (forgotPassordForm) {
            forgotPassordForm.onsubmit = () => {
                this.requestResetPassword();
                return false;
            };
        }

        // change password popup
        const changePasswordForm = document.getElementById("account--reset-password-form");
        if (changePasswordForm) {
            changePasswordForm.onsubmit = () => {
                this.requestChangePassword();
                return false;
            };
        }

        const resetPassword = document.getElementById("account--reset-password-resend");
        if (resetPassword) {
            resetPassword.onclick = () => authentication.showRequestResetPasswordPopup();
        }

        const accountReopen = document.getElementById("account--status-reopen");
        if (accountReopen) {
            accountReopen.onclick = () => {
                this.requestReopenAccount();
            };
        }

        const accountReopenCancel = document.getElementById("account--status-reopen-cancel");
        if (accountReopenCancel) {
            accountReopenCancel.onclick = () => {
                window && window.location.reload()
            };
        }
    },
    hidePopups: function () {
        [...document.querySelectorAll('.popup')].map(popup => {
            popup.classList.remove('active');
        });
        utility.htmlScroll('initial');
    },
    requestLogin: function () {
        const ajaxOptions = {
            url: "/api/web/authentication/login",
            method: "POST",
            data: utility.getFormData(document.querySelector("#authentication--signin-form")),
            success: function (e) {
                const result = JSON.parse(e.target.responseText);
                if (result.status === "OK" || result.status === "AM" || result.status === "PC") {
                    if (window.braze) {
                        window.braze.changeUser(result.externalId);
                        setTimeout(function () {
                            window.location.href = result.returnUrl;
                        }, 500);
                    } else {
                        window.location.href = result.returnUrl;
                    }
                }
                else {
                    const generalError = document.getElementById("authentication--signin-form-general-error");
                    const closeIcon = document.getElementById("login-close-icon");

                    if (generalError) {
                        generalError.style.display = "none";
                    }

                    const form = document.getElementById("authentication--signin-form");
                    utility.removeFormInputErrors(form);

                    if (result.status === "IL") {
                        const errorContent = document.createElement("span");
                        errorContent.innerHTML = result.error;
                        const link1 = errorContent.querySelector("a");
                        if (link1) {
                            link1.onclick = () => utility.showPopup(document.getElementById("global--forgot-password-popup"));
                        }
                        utility.showNotificationPopup({
                            title: "",
                            content: errorContent
                        });
                    }
                    else if (result.status === "SC") {
                        utility.showNotificationPopup({
                            title: "Security Alert",
                            content: 'Contact <a href="/contact/">Customer Support (07) 2111 8242</a>'
                        });
                    }
                    else if (result.status === "LO" || result.status === "LT" || result.status === "IL") {
                        generalError.style.display = "";
                        generalError.innerHTML = result.error;
                        const link2 = generalError.querySelector("span");
                        if (link2) {
                            link2.onclick = () => utility.showPopup(document.getElementById("global--forgot-password-popup"));
                        }
                    }
                    else if (result.status === "AC") {
                        // Account Closed - hide login form and show support options
                        [...document.querySelectorAll("#authentication--signin-popup .side-borders")].map(el => {
                            el.style.display = "none";
                        });

                         [...document.querySelectorAll("#authentication--signin-popup form")].map(el => {
                            el.style.display = "none";                       
                         });

                        document.getElementById("popup-account-closed-message").style.display = "block";  

                        if (closeIcon) {
                            closeIcon.onclick = () => {
                                window && window.location.reload();
                            };
                        }
                    }
                    else if (result.status === "RCA") {
                        document.getElementById("account--status-reopen").setAttribute('data-reference', result.referenceNo);
                        document.getElementById("account--status-reopen").setAttribute('data-token', result.reOpenTokenValue);
                        utility.showPopup(document.getElementById("authentication--signin-popup-reopen-closed-account"));


                        const reopenClosedAccountIcon = document.getElementById("login-close-reopen-closed-account-icon");
                        if (reopenClosedAccountIcon) {
                            reopenClosedAccountIcon.onclick = () => {
                                window && window.location.reload();
                            };
                        }
                    }
                    else {
                        generalError.style.display = "";
                        generalError.innerHTML = result.error;
                    }
                }
            },
            error: function(e) {
                const generalError = document.getElementById("authentication--signin-form-general-error");
                generalError.style.display = "";
                if (e.currentTarget.status && e.currentTarget.status === 403) {
                    generalError.innerHTML = "Unable to log you in at this time.<br/>Please try again later.";
                }
                else {
                    generalError.innerHTML = "An error occurred logging you in.<br/>Please try again later.";
                }
            },
            always: function () {
                utility.enableButton(document.querySelector("#authentication--signin-form button[type=submit]"));
            }
        };
        utility.disableButton(document.querySelector("#authentication--signin-form button[type=submit]"));
        utility.ajaxRequest(ajaxOptions);
    },

    requestSMSCode: function () {
        const ajaxOptions = {
            url: "/request-login-sms-code",
            method: "POST",
            data: utility.getFormData(document.querySelector("#authentication--signin-sms")),
            success: function (e) {
                const result = JSON.parse(e.target.responseText);

                if (result.status === "SE") {
                    const codeForm = document.getElementById("authentication--signin-code");
                    const loginForm = document.getElementById("authentication--signin-sms");
                    const phoneNumber = loginForm.querySelector("input[name='phoneNumber']").value;

                    loginForm.style.display = "none";
                    document.getElementById("authentication--signin-code").style.display = "block";
                    codeForm.querySelector("h2").innerHTML = `Enter the 6-digit code sent to **** *** ${phoneNumber.slice(-3)} to log in`;
                    codeForm.querySelector("input[name='code']").focus();
                    codeForm.querySelector("input[name='token']").value = result.token;
                    authentication.setResendCodeTimer();

                    utility.removeClass(document.getElementById("login-code-buttton"), "display-none");
                    utility.addClass(document.getElementById("login-code-buttton"), "display-block");
                }
                else {
                    const generalError = document.getElementById("authentication--sms-form-general-error");
                    const closeIcon = document.getElementById("login-close-icon");

                    if (generalError) {
                        utility.addClass(generalError, "display-none");
                    }
                    utility.removeClass(generalError, "display-none");
                    utility.addClass(generalError, "display-block");
                    generalError.innerHTML = result.error;

                    if (result.status === "LO" || result.status === "IA" || result.status === "LR") {
                        // If Locked or Inactive Acc hide all CTA
                        //LR Limit reached
                        const btnSendCode = document.getElementById("btn-send-code");
                        utility.removeClass(btnSendCode, "display-block");
                        utility.addClass(btnSendCode, "display-none");
                        //try {
                        //    this.clearForms(); 
                        //}
                        //catch (err) {
                        //   // console.log(err);
                        //}
                    }

                    if (result.status === "IT") {
                    // Session expired             
                        const btnSendCode = document.getElementById("btn-send-code");
                        utility.removeClass(btnSendCode, "display-block");
                        utility.addClass(btnSendCode, "display-none");

                        // Hide the Resend Code button
                        utility.removeClass(document.getElementById("resend-sms-code"), "display-block");
                        utility.addClass(document.getElementById("resend-sms-code"), "display-none");
                    }


                    if (result.status === "AC") {
                        // Account Closed - hide login form and show support options
                        [...document.querySelectorAll("#authentication--signin-popup .side-borders")].map(el => {
                            el.style.display = "none";
                        });
                        [...document.querySelectorAll("#authentication--signin-popup form")].map(el => {
                            el.style.display = "none";
                        });
                        document.getElementById("popup-account-closed-message").style.display = "block";

                        if (closeIcon) {
                            closeIcon.onclick = () => {
                                window && window.location.reload();
                            };
                        }
                    }
                    else if (result.status === "RCA") {
                        document.getElementById("account--status-reopen").setAttribute('data-reference', result.referenceNo);
                        document.getElementById("account--status-reopen").setAttribute('data-token', result.reOpenTokenValue);
                        utility.showPopup(document.getElementById("authentication--signin-popup-reopen-closed-account"));

                        const reopenClosedAccountIcon = document.getElementById("login-close-reopen-closed-account-icon");
                        if (reopenClosedAccountIcon) {
                            reopenClosedAccountIcon.onclick = () => {
                                window && window.location.reload();
                            };
                        }
                    }
                }
            },
            always: function () {
                utility.enableButton(document.querySelector("#authentication--signin-sms button[type=submit]"));
            }
        };
        utility.disableButton(document.querySelector("#authentication--signin-sms button[type=submit]"));
        utility.ajaxRequest(ajaxOptions);
    },

    requestSMSLogin: function () {
        const ajaxOptions = {
            url: "/login-sms-code",
            method: "POST",
            data: utility.getFormData(document.querySelector("#authentication--signin-code")),
            success: function (e) {
                const result = JSON.parse(e.target.responseText);
                if (result.status === "OK") {
                    window.location.href = result.returnUrl;
                }
                else {
                    const closeIcon = document.getElementById("login-close-icon");
                    const generalError = document.getElementById("authentication--sms-code-general-error");
                    if (generalError) {
                        generalError.style.display = "none";
                    }
                    generalError.style.display = "";
                    generalError.innerHTML = result.error;    

                    if (result.status === "VE") {

                        utility.removeClass(generalError, "display-none");
                        utility.addClass(generalError, "display-block");

                        // code expired - 5 mins
                        utility.removeClass(document.getElementById("send-new-code"), "display-none");
                        utility.addClass(document.getElementById("send-new-code"), "display-block");

                        utility.removeClass(document.getElementById("resend-sms-code"), "display-block");
                        utility.addClass(document.getElementById("resend-sms-code"), "display-none");

                        const codeForm = document.getElementById("authentication--signin-code");
                        codeForm.querySelector("input[name='code']").value = "";
                        codeForm.querySelector("input[name='code']").focus();

                        const sendNewCode = document.getElementById("send-new-code");
                        if (sendNewCode) {
                            sendNewCode.onclick = () => {
                                // Hide the Send New Code link
                                utility.removeClass(document.getElementById("send-new-code"), "display-block");
                                utility.addClass(document.getElementById("send-new-code"), "display-none");

                                // Hide the Resend Code button
                                utility.removeClass(document.getElementById("resend-sms-code"), "display-block");
                                utility.addClass(document.getElementById("resend-sms-code"), "display-none");

                                utility.addClass(document.getElementById("authentication--sms-code-general-error"), "display-none");
                                authentication.resendSMSCode("newcode");
                            }
                        }
                    } else if (result.status === "VL" || result.status === "LT" || result.status === "LO" || result.status === "IA") {
                      //Entered Invalid Code too many times or account is invalid - hide login+resend button
                        authentication.setResendCodeTimer("cancel");
                        utility.addClass(document.getElementById("send-new-code"), "display-none");
                        utility.addClass(document.getElementById("resend-sms-code"), "display-none");

                        utility.removeClass(document.getElementById("login-code-buttton"), "display-block");
                        utility.addClass(document.getElementById("login-code-buttton"), "display-none");

                        utility.removeClass(generalError, "display-none");
                        utility.addClass(generalError, "display-block");

                        //show CANCEL button if IA
                        if (result.status === "IA") {
                            //If session time out show CANCEL and reset forms on press
                            utility.removeClass(document.getElementById("clear-sms-forms"), "display-none");
                            utility.addClass(document.getElementById("clear-sms-forms"), "display-block");
                         }
                    }
                    if (result.status === "VI") {
                        // If incorrect code, clear the input field
                        const codeForm = document.getElementById("authentication--signin-code");
                        codeForm.querySelector("input[name='code']").value="";
                        codeForm.querySelector("input[name='code']").focus();

                        utility.removeClass(generalError, "display-none");
                        utility.addClass(generalError, "display-block");
                    }
                    if (result.status === "AC") {
                        // Account Closed - hide login form and show support options
                        [...document.querySelectorAll("#authentication--signin-popup .side-borders")].map(el => {
                            el.style.display = "none";
                        });
                        [...document.querySelectorAll("#authentication--signin-popup form")].map(el => {
                            el.style.display = "none";
                        });
                        document.getElementById("popup-account-closed-message").style.display = "block";

                        if (closeIcon) {
                            closeIcon.onclick = () => {
                                window && window.location.reload();
                            };
                        }
                    }
                    else if (result.status === "RCA") {
                        document.getElementById("account--status-reopen").setAttribute('data-reference', result.referenceNo);
                        document.getElementById("account--status-reopen").setAttribute('data-token', result.reOpenTokenValue);
                        utility.showPopup(document.getElementById("authentication--signin-popup-reopen-closed-account"));

                        const reopenClosedAccountIcon = document.getElementById("login-close-reopen-closed-account-icon");
                        if (reopenClosedAccountIcon) {
                            reopenClosedAccountIcon.onclick = () => {
                                window && window.location.reload();
                            };
                        }
                    }
                    // if code is LR error message is shown along with CTA for the final try

                }
            },
            always: function () {
                utility.enableButton(document.querySelector("#authentication--signin-code button[type=submit]"));
            }
        };
        utility.disableButton(document.querySelector("#authentication--signin-code button[type=submit]"));
        utility.ajaxRequest(ajaxOptions);
    },

    resendSMSCode: function (newCode) {
        const btnLoginCode = document.getElementById("login-code-buttton");
        const btnResendSmsCode = document.getElementById("resend-sms-code");
        utility.removeClass(btnResendSmsCode, "display-block");
        utility.addClass(btnResendSmsCode, "display-none");

        const ajaxOptions = {
            url: "/resend-login-sms-code",
            method: "POST",
            data: "token=" + document.getElementById("authentication--signin-code").querySelector("input[name='token']").value + "&actionId=LOG&returnUrl='/'",
            success: function (e) {
                const generalError = document.getElementById("authentication--sms-code-general-error");
                generalError.style.display = "none";

                const result = JSON.parse(e.target.responseText);

                //Update form token
                if (result.token) {
                    document.getElementById("authentication--signin-code").querySelector("input[name='token']").value = result.token
                }


                if (result.status === "SE") {
                    if (generalError) {
                        utility.removeClass(generalError, "display-block");
                        utility.addClass(generalError, "display-none");
                    }
                    if (newCode) {
                    // display 'Code Resent'
                    // set 10 secs timert
                        const resentMessage = document.getElementById("resent-message");
                        utility.removeClass(resentMessage, "display-none");
                        utility.addClass(resentMessage, "display-block");
                    }
                    authentication.setResendCodeTimer();
                }
                else {
                    if (generalError) {
                        utility.removeClass(generalError, "display-block");
                        utility.addClass(generalError, "display-none");
                    }

                    utility.removeClass(generalError, "display-none");
                    utility.addClass(generalError, "display-block");

                    generalError.innerHTML = result.error;

                    //Cater for Too many sms resend - show message and login buton for this particular case where they have exhausted their 3 resend clicks but received the resend code late or on thruid request

                    if (result.status === "LO" || result.status === "IA" || result.status === "IT" || result.status === "VL") {        
                        //IT - code expired 24 hours
                        //IA Inactive acc
                        // Locked
                        // Please Contact Support message is displayed - hide all CTA
                        utility.removeClass(btnLoginCode, "display-block");
                        utility.addClass(btnLoginCode, "display-none");

                        utility.removeClass(btnResendSmsCode, "display-block");
                        utility.addClass(btnResendSmsCode, "display-none");

                        //display errors if any is hidden
                        utility.removeClass(generalError, "display-none");
                        utility.addClass(generalError, "display-block");
                    }



                        //If db issues still show resend
                    if (result.status === "ER") {
                        utility.removeClass(document.getElementById("resend-sms-code"), "display-none");
                        utility.addClass(document.getElementById("resend-sms-code"), "display-block");
                    }

                    //show CANCEL button if ID or IT (24 hours)
                    if (result.status === "ID" || result.status === "IT") {
                        //If session time out show CANCEL and reset forms on press
                        utility.removeClass(document.getElementById("clear-sms-forms"), "display-none");
                        utility.addClass(document.getElementById("clear-sms-forms"), "display-block");
                    }


                     if (result.status === "AC") {
                        // Account Closed - hide login form and show support options
                        [...document.querySelectorAll("#authentication--signin-popup .side-borders")].map(el => {
                            el.style.display = "none";
                        });
                         [...document.querySelectorAll("#authentication--signin-popup form")].map(el => {
                             el.style.display = "none";
                         });
                        document.getElementById("popup-account-closed-message").style.display = "block";
                    }

                
                    if (result.status === "RF") {
                        //finalising your previous request
                        //re enable resend btn while other req is going on
                        utility.removeClass(btnResendSmsCode, "display-none");
                        utility.addClass(btnResendSmsCode, "display-block");
                    }

                }
            }
        };
        utility.ajaxRequest(ajaxOptions);
    },

    setResendCodeTimer: function (cancel) {
        let counter = 10;
        const resendSmsCode = document.getElementById("resend-sms-code");
        const resentMessage = document.getElementById("resent-message");
        //const resentCounter = document.getElementById("resent-counter");
        utility.removeClass(resendSmsCode, "display-block");
        utility.addClass(resendSmsCode, "display-none");

        if (cancel) {
            // If too many code attempts, hide resend functionality
            clearInterval(window.resendTimer);
            utility.removeClass(resendSmsCode, "display-block");
            utility.addClass(resendSmsCode, "display-none");
            utility.removeClass(resentMessage, "display-block");
            utility.addClass(resentMessage, "display-none");
            //utility.removeClass(resentCounter, "display-block");
            //utility.addClass(resentCounter, "display-none");
        } else {
            window.resendTimer && clearInterval(window.resendTimer);
            window.resendTimer = setInterval(function () {
                //utility.removeClass(resentCounter, "display-none");
                //utility.addClass(resentCounter, "display-block");
                //resentCounter.innerHTML = `Resend Code in ${counter} secs`;
                if (counter == 0) {
                    utility.removeClass(resendSmsCode, "display-none");
                    utility.addClass(resendSmsCode, "display-block");
                    utility.removeClass(resentMessage, "display-block");
                    utility.addClass(resentMessage, "display-none");
                    //utility.removeClass(resentCounter, "display-block");
                    //utility.addClass(resentCounter, "display-none");
                    clearInterval(window.resendTimer);
                }
                counter--;
            }, 1000);

        }

    },

    clearForms: function () {
        const codeForm = document.getElementById("authentication--signin-code");
        const loginForm = document.getElementById("authentication--signin-sms");

        //always hide Cancel Button
        utility.removeClass(document.getElementById("clear-sms-forms"), "display-block");
        utility.addClass(document.getElementById("clear-sms-forms"), "display-none");

        //clear all messages
        utility.removeClass(document.getElementById("authentication--sms-form-general-error"), "display-block");
        utility.addClass(document.getElementById("authentication--sms-form-general-error"), "display-none");
        utility.removeClass(document.getElementById("authentication--sms-code-general-error"), "display-block");
        utility.addClass(document.getElementById("authentication--sms-code-general-error"), "display-none");


        codeForm.reset();
        loginForm.reset();
        codeForm.style.display = "none";
        loginForm.style.display = "block";

        //clear token
        document.getElementById("authentication--signin-code").querySelector("input[name='token']").value = "";
    },
    showRequestResetPasswordPopup: function() {
        authentication.clearRequestResetPasswordEmail();
        utility.showPopup(document.querySelector("#global--forgot-password-popup"));
    },

    requestResetPassword: function () {
        const ajaxOptions = {
            url: "/api/web/account/request-reset-password",
            method: "POST",
            data: utility.getFormData(document.querySelector("#global--forgot-password-form")),
            success: function (e) {
                var result = JSON.parse(e.target.responseText);
                if (result.success) {
                    authentication.clearRequestResetPasswordEmail();
                    utility.showNotificationPopup({
                        title: "Please check your email inbox",
                        content: result.message
                    });
                }
                else if (result.message) {
                    const form = document.getElementById("global--forgot-password-form");
                    utility.addFormInputError(form, "username", result.message);
                }
                else {
                    utility.showNotificationPopup({
                        title: "An error occurred while requesting a password reset",
                        content: result.message
                    });
                }
            },
            always: function () {
                utility.enableButton(document.querySelector("#global--forgot-password-form button[type=submit]"));
            }
        };
        utility.disableButton(document.querySelector("#global--forgot-password-form button[type=submit]"));
        utility.ajaxRequest(ajaxOptions);
    },

    clearRequestResetPasswordEmail: function() {
        const form = document.getElementById("global--forgot-password-form");
        if (form) {
            form.querySelector("input[type='text']").value = "";
        }
    },

    requestChangePassword: function () {
        const ajaxOptions = {
            url: "/api/web/account/reset-password",
            method: "POST",
            data: utility.getFormData(document.querySelector("#account--reset-password-form")),
            success: function (e) {
                const result = JSON.parse(e.target.responseText);
                const form = document.querySelector("#account--reset-password-form");
                utility.removeFormInputErrors(form);

                if (result.resultCode === "S") {
                    document.querySelector("#account--reset-password-container").style.display = "none";
                    document.querySelector("#account--reset-password-success").style.display = "inherit";
                }
                else {
                    utility.addFormInputError(form, result.fieldError.Name, result.fieldError.Error);
                }
            },
            always: function () {
                utility.enableButton(document.querySelector("#account--reset-password-form button[type=submit]"));
            }
        };
        utility.disableButton(document.querySelector("#account--reset-password-form button[type=submit]"));
        utility.ajaxRequest(ajaxOptions);
    },

    requestReopenAccount: function () {
        const reference = document.getElementById("account--status-reopen").getAttribute('data-reference');
        const tokenValue = document.getElementById("account--status-reopen").getAttribute('data-token');
        const ajaxOptions = {
            url: "/api/web/account/reopen-account",
            method: "POST",
            data: "reference=" + reference + "&tokenValue=" + tokenValue,
            success: function (e) {
                const result = JSON.parse(e.target.responseText);
                if (result.success) {
                    var message = result.messages[0];
                    if (result.messages.length > 1) {
                        for (var i = 1; i < result.messages.length; i++) {
                            message = message + "<br/><br/>" + result.messages[i];
                        }
                    }
                    utility.showNotificationPopup({
                        title: "Success!",
                        content: message,
                        hideCloseIcon: true,
                        button: {
                            text: "OK",
                            url: "/account/"
                        }
                    });
                }
                else {
                    utility.showNotificationPopup({
                        title: "Error",
                        content: result.messages[0]
                    });
                }
            },
            always: function () {
                utility.enableButton(document.getElementById("account--status-reopen"));
                utility.enableButton(document.getElementById("account--status-reopen-cancel"));
            }
        };
        utility.disableButton(document.getElementById("account--status-reopen"));
        utility.disableButton(document.getElementById("account--status-reopen-cancel"));
        utility.ajaxRequest(ajaxOptions);
    },

}

export default authentication



// WEBPACK FOOTER //
// ./assets/src/js/classes/authentication.js